import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { getLocale } from 'src/replicant/getters/user';
import StateObserver from 'src/StateObserver';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

import { AssetGroup } from '@play-co/timestep-core';

type CloseHandler = (accepted: boolean) => void;

const ui = uiConfig.buruburu.invite.confirm;
export default class PopupPNPermissionReminder extends PopupBasic {
  constructor(opts: { superview: View; close: CloseHandler }) {
    super({
      superview: opts.superview,
      close: () => opts.close(false),
      ...ui.popup,
      height: 666,
      tracking: {
        feature: Feature.PUSH_NOTIFICATION._,
        $subFeature: Feature.PUSH_NOTIFICATION.PERMISSION_REMINDER_POPUP._,
      },
    });

    this.message.updateOpts({
      ...ui.message,
      width: 500,
      height: 96,
      x: (this.box.style.width - 500) / 2,
    });

    this.box.addSubview(
      new ImageScaleView({
        ...ui.underline,
        width: 284,
        y: 420,
        centerOnOrigin: true,
        x: this.box.style.width / 2,
      }),
    );

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...ui.okButton,
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: 574,
        localeText: () => i18n('basic.ok'),
        onClick: async () => {
          sounds.sfx.play('ok');
          return opts.close(true);
        },
        tracking: {
          feature: Feature.PUSH_NOTIFICATION._,
          $subFeature: Feature.PUSH_NOTIFICATION.PERMISSION_REMINDER_POPUP.OK,
        },
      }),
    );

    this.box.addSubview(
      new LangBitmapFontTextView({
        align: 'center',
        verticalAlign: 'center',
        size: getLocale(StateObserver.getState().user) === 'ja' ? 22 : 20,
        color: '#BF8147',
        wordWrap: true,
        font: 'Body',
        centerOnOrigin: true,
        x: this.box.style.width / 2,
        y: 478,
        width: 531,
        height: 72,
        localeText: () => i18n('pushNotification.permission.reminderStep'),
      }),
    );
  }

  protected getAssetsGroup() {
    const localePreffix =
      getLocale(StateObserver.getState().user) === 'en' ? 'en' : 'jp';
    return new AssetGroup([
      `assets/ui/pushnotification/${localePreffix}/crabsick.png`,
    ]);
  }

  public init() {
    super.init({
      title: i18n('pushNotification.permission.title'),
      message: i18n('pushNotification.permission.message'),
    });

    const localePreffix =
      getLocale(StateObserver.getState().user) === 'en' ? 'en' : 'jp';

    new ImageScaleView({
      superview: this.box,
      width: 480,
      height: 182,
      centerOnOrigin: true,
      x: this.box.style.width / 2 - 12,
      y: 281,
      image: `assets/ui/pushnotification/${localePreffix}/crabsick.png`,
    });
  }
}
